import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { GoogleFormsService } from 'src/app/services/google-forms.service';

enum QuestionnaireState {
  INTRO = 0,
  QUESTIONS = 1,
  EMAIL = 2,
  RESULTS = 3,
}

@Component({
  selector: 'app-questionnaire',
  templateUrl: './questionnaire.component.html',
  styleUrls: ['./questionnaire.component.scss']
})
export class QuestionnaireComponent {
  state: QuestionnaireState = QuestionnaireState.INTRO;
  score: number;
  result: string;
  
  questionnaire: FormGroup = new FormGroup({
    one: new FormControl('', Validators.required),
    two: new FormControl('', Validators.required),
    three: new FormControl('', Validators.required),
    four: new FormControl('', Validators.required),
    five: new FormControl('', Validators.required),
    six: new FormControl('', Validators.required),
    seven: new FormControl('', Validators.required),
    eight: new FormControl('', Validators.required),
    nine: new FormControl('', Validators.required),
    ten: new FormControl('', Validators.required),
  });

  emailAddressForm: FormGroup = new FormGroup({
    emailAddress: new FormControl('', Validators.required),
  })
  
  results = {
    low: 'you do not have an issue',
    med: 'you are on the brink of having an issue',
    high: 'you have an issue, please get referred',
  }

  resultsCalc(score: number) {
    let result;
    if (score < 3) {
      result = this.results.low;
    } else if (score < 6) {
      result = this.results.med;
    } else {
      result = this.results.high;
    }
    return result;
  }

  questions = [
    {number: 'one', question: 'Have you used drugs other than those required for medical reasons?', yes: 1, no: 0},
    {number: 'two', question: 'Do you abuse more than one drug at a time?', yes: 1, no: 0},
    {number: 'three', question: 'Are you unable to stop using drugs when you want to?', yes: 0, no: 1},
    {number: 'four', question: 'Have you ever had blackouts or flashbacks as a result of drug use?', yes: 1, no: 0},
    {number: 'five', question: 'Do you ever feel bad or guilty about your drug use?', yes: 1, no: 0},
    {number: 'six', question: 'Does your spouse (or parents) ever complain about your involvement with drugs?', yes: 1, no: 0},
    {number: 'seven', question: 'Have you neglected your family because of your use of drugs?', yes: 1, no: 0},
    {number: 'eight', question: 'Have you engaged in illegal activities in order to obtain drugs? ', yes: 1, no: 0},
    {number: 'nine', question: 'Have you ever experienced withdrawal symptoms (felt sick) when you stopped taking drugs?', yes: 1, no: 0},
    {number: 'ten', question: 'Have you had medical problems as a result of your drug use (e.g. memory loss, hepatitis, convulsions, bleeding)?', yes: 1, no: 0},
  ]

  constructor(private googleFormsService: GoogleFormsService ) {}

  onTakeTest(){
    this.state = QuestionnaireState.QUESTIONS;
  }


  onQuestionnaireSubmit(){
    this.state = QuestionnaireState.EMAIL;
  }

  onEmailAddressSubmit(){
    this.score = Object.entries(this.questionnaire.value as number[]).reduce((acc, [_, v]) => acc + v, 0);
    this.result = this.resultsCalc(this.score);
    this.googleFormsService.postEmailToForm(this.emailAddressForm.value.emailAddress).subscribe(() => {});
    this.state = QuestionnaireState.RESULTS;
  }
}
